import {put, call, takeLatest} from 'redux-saga/effects';
import branchApi from '../api/branch.api';
import * as ActionTypes from '../actions/types.action';
import {arrayToObject} from '../helpers/array.helper';
import {registerBranches} from '../helpers/branch.helper';

function* getBranchList() {
  try {
    const branchListArray = yield call(branchApi.getAllBranch);
    // Mirrors the server-side registration, so branch URLs resolve the same way
    // after a client-side navigation as they do on the rendered page.
    registerBranches(branchListArray);
    const branchList = arrayToObject(branchListArray, 'code');
    yield put({type: ActionTypes.GET_BRANCH_LIST_SUCCESS, branchList});
  } catch (e) {
    yield put({type: ActionTypes.GET_BRANCH_LIST_FAILED, message: e.message});
  }
}

export default function* getBranchListYield() {
  yield takeLatest(ActionTypes.GET_BRANCH_LIST_REQUESTED, getBranchList);
}
